import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-normal-table',
  templateUrl: './normal-table.component.html',
  styleUrls: ['./normal-table.component.scss']
})
export class NormalTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
